import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  
  import { Router } from '@angular/router';
  import { DatePipe } from '@angular/common';
  import { FormsModule } from '@angular/forms';
  import { StudentService } from '../../services/student.service';
  
  import { IdentificationService } from '../../services/identification.service';
  import { PaginationComponent } from '../ui/pagination/pagination.component';
  
  @Component({
    selector: 'app-identification-list',
    standalone: true,
    imports: [
      DatePipe,
      FormsModule,
      PaginationComponent,
    ],
    templateUrl: './identification-list.html',
    styleUrl: './identification-list.scss',
  })
  export class IdentificationListComponent
    implements OnInit
  {
    private identificationService = inject(
      IdentificationService,
    );
  
    private studentService = inject(StudentService);
    private router = inject(Router);
    
  
    private cdr = inject(ChangeDetectorRef);
  
    identifications: any[] = [];
    page = 1;
    pageSize = 6;

    get pagedIdentifications(): any[] {
      const start = (this.page - 1) * this.pageSize;
      return this.identifications.slice(start, start + this.pageSize);
    }
  
    isLoading = true;
  
    showCreateForm = false;
  
    isCreating = false;
  
    linkerName = '';
    students: any[] = [];
    selectedStudentId = '';
    responsibleName = '';
    species = 'DOG';
    animalName = '';
    phone = '';
    plateDesign = '';
    material = 'STEEL';
    abaqCost: number | null = null;
    providerCost: number | null = null;
    paymentProofUrl = '';
    status = 'PENDING';
  
    ngOnInit(): void {
      this.loadIdentifications();
      this.loadStudents();
    }

    copyFormLink(): void {
        const formUrl =
          `${window.location.origin}/formularios/placas`;
      
        navigator.clipboard
          .writeText(formUrl)
          .then(() => {
            alert('Enlace del formulario copiado correctamente.');
          })
          .catch((error) => {
            console.error(
              '🔴 ERROR COPIANDO ENLACE:',
              error,
            );
          });
      }
  
    loadIdentifications(): void {
      this.isLoading = true;
  
      this.identificationService
        .getAllIdentifications()
        .subscribe({
          next: (response: any) => {
            console.log(
              '🟢 IDENTIFICACIONES:',
              response,
            );
  
            this.identifications =
              response.data.documents;
  
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR CARGANDO IDENTIFICACIONES:',
              error,
            );
  
            this.identifications = [];
  
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
        });
    }

    loadStudents(): void {
        this.studentService
          .getAllStudents()
          .subscribe({
            next: (response: any) => {
              console.log(
                '🟢 ESTUDIANTES PARA PLACAS:',
                response,
              );
      
              this.students = response;
      
              this.cdr.detectChanges();
            },
      
            error: (error) => {
              console.error(
                '🔴 ERROR CARGANDO ESTUDIANTES:',
                error,
              );
      
              this.students = [];
      
              this.cdr.detectChanges();
            },
          });
      }
  
    openCreateForm(): void {
      this.showCreateForm = true;
  
      this.resetForm();
    }
  
    closeCreateForm(): void {
      this.showCreateForm = false;
  
      this.resetForm();
    }
  
    resetForm(): void {
      this.linkerName = '';
      this.responsibleName = '';
      this.species = 'DOG';
      this.animalName = '';
      this.phone = '';
      this.plateDesign = '';
      this.material = 'STEEL';
      this.abaqCost = null;
      this.providerCost = null;
      this.paymentProofUrl = '';
      this.status = 'PENDING';
    }
  
    createIdentification(): void {
      if (
        !this.selectedStudentId ||
        !this.responsibleName ||
        !this.species ||
        !this.animalName ||
        !this.material
      ) {
        return;
      }
  
      this.isCreating = true;
  
      const selectedStudent = this.students.find(
        (student) =>
          student.id === this.selectedStudentId,
      );
      
      const identification = {
        linkerName:
          selectedStudent?.fullName ?? '',
        studentRef: this.selectedStudentId,
        responsibleName:
          this.responsibleName,
        species: this.species,
        animalName: this.animalName,
        phone: this.phone,
        plateDesign: this.plateDesign,
        material: this.material,
        abaqCost: this.abaqCost ?? 0,
        providerCost:
          this.providerCost ?? 0,
        paymentProofUrl:
          this.paymentProofUrl,
        status: this.status,
      };
  
      console.log(
        '🔵 ENVIANDO IDENTIFICACIÓN:',
        identification,
      );
  
      this.identificationService
        .createIdentification(
          identification,
        )
        .subscribe({
          next: (response: any) => {
            console.log(
              '🟢 IDENTIFICACIÓN CREADA:',
              response,
            );
  
            const newIdentification =
              response.data.document;
  
            this.identifications = [
              newIdentification,
              ...this.identifications,
            ];
  
            this.isCreating = false;
  
            this.showCreateForm = false;
  
            this.resetForm();
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR CREANDO IDENTIFICACIÓN:',
              error,
            );
  
            this.isCreating = false;
  
            this.cdr.detectChanges();
          },
        });
    }
  
    viewIdentification(id: string): void {
      this.router.navigate([
        '/admin/identifications',
        id,
      ]);
    }
  }